import moment from 'moment';

export const dateComparator = (valueA, valueB) => {
  const dateA = moment(valueA).utcOffset(0, true);
  const dateB = moment(valueB).utcOffset(0, true);

  if (!dateA.isValid()) {
    return 1;
  } else if (!dateB.isValid()) {
    return -1;
  } else {
    if (dateA.isSame(dateB)) {
      return 0;
    }
    return (dateA.isBefore(dateB)) ? 1 : -1;
  }

};
